<div class="w-100" style="display: flex; align-items: center; justify-content: space-between;">
  <h3 style="
  margin: 25px;
  font-weight: 500;
  font-size: 25px;
  color: #2a457a;
  display: flex;
  align-items: center;
  gap: 10px;
">

    <span style="display:flex; align-items:center;">
      <mat-icon style="font-size:28px; height:28px; width:28px; color:#1e88e5; position:relative; margin-bottom: 3px;">
        verified
      </mat-icon>
    </span>

    Receipt Verification
  </h3>
</div>

<div class="border-p table-container">
  <!-- Financial Year -->
  <mat-form-field class="w-30 pl-20" appearance="outline">
    <mat-label class="custom-mat-label">Financial Year</mat-label>
    <mat-select matNativeControl required [(ngModel)]="l_formDataDaybook.finyearmstId">
      <mat-select-trigger>
        {{ lFN_GetFinancialYearText(l_formDataDaybook.finyearmstId) }}
      </mat-select-trigger>
      <mat-option *ngFor="let l_financialyear of l_financialYearList" [value]="l_financialyear.finyearmstId">
        <div class="option-container">
          <span>{{ l_financialyear.finyear }}</span>
          <ng-container *ngIf="l_financialyear.status">
            <mat-icon class="active-icon">check_circle</mat-icon>
          </ng-container>
        </div>
      </mat-option>
    </mat-select>
  </mat-form-field>
  <!-- Category name -->
  <mat-form-field class="w-20 pl-10" appearance="outline">
    <mat-label class="custom-mat-label">Txncategory</mat-label>
    <mat-select required multiple [(ngModel)]="l_formDataDaybook.txnCategories">
      <mat-option *ngFor="let l_category of l_categoryList" [value]="l_category.txncategoryId">
        {{ l_category.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <!-- Book Number -->
  <mat-form-field class="w-15 pl-20" appearance="outline">
    <mat-label class="custom-mat-label">Book Number</mat-label>
    <input required matInput type="number" placeholder="Enter Book No" [(ngModel)]="l_formDataDaybook.bookNo"
      (ngModelChange)="lFN_FilterDaybookDetails();">
  </mat-form-field>
  <!-- Fetch All -->
  <button mat-raised-button color="primary" class="custom-button-blue ml-15"
    (click)="lFN_GetReceiptVerificationList();">
    View All
  </button>
</div>

<mat-tab-group>

  <!-- UNVERIFIED RECEIPTS TAB -->
  <mat-tab label="Unverified Receipts">
    <div class="mat-elevation-z8 table-container">

      <table mat-table [dataSource]="unverifiedDataSource" class="mat-table fixed-table" matSort>
        <!-- Category -->
        <ng-container matColumnDef="category">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Category</th>
          <td mat-cell *matCellDef="let row">{{ row.txncategory?.name }}</td>
        </ng-container>

        <!-- Book No -->
        <ng-container matColumnDef="bookNo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="bookNo">B.No</th>
          <td mat-cell *matCellDef="let row">{{ row.bookNo }}</td>
        </ng-container>

        <!-- Receipt No -->
        <ng-container matColumnDef="receiptNo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="receiptNo">Receipt No</th>
          <td mat-cell *matCellDef="let row">{{ row.transaction?.receiptIdPrefixed }}</td>
        </ng-container>

        <!-- Date -->
        <ng-container matColumnDef="txnDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
          <td mat-cell *matCellDef="let row">{{ row.transaction?.txnDate | date:'dd/MM/yyyy' }}</td>
        </ng-container>

        <!-- Purpose -->
        <ng-container matColumnDef="purpose">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Purpose</th>
          <td mat-cell *matCellDef="let row">{{ row.purpose?.name }}</td>
        </ng-container>

        <!-- Mode -->
        <ng-container matColumnDef="modeOfPayment">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Mode</th>
          <td mat-cell *matCellDef="let row">{{ row.modeOfPayment }}</td>
        </ng-container>

        <!-- Cheque / Transaction No -->
        <ng-container matColumnDef="txnId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Chequeno/TxnID</th>
          <td mat-cell *matCellDef="let row">{{ row.transaction?.txnId }}</td>
        </ng-container>

        <!-- Bank Name -->
        <ng-container matColumnDef="bank">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Bank Name</th>
          <td mat-cell *matCellDef="let row">{{ row.modeBankName || '-' }}</td>
        </ng-container>

        <!-- Customer Name -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let row">
            {{
            (row.accountsDetails?.salutation ? row.accountsDetails.salutation + ' ' : '') +
            (row.accountsDetails?.firstName ? row.accountsDetails.firstName + ' ' : '') +
            (row.accountsDetails?.lastName || '') || '-'
            }}
          </td>
        </ng-container>

        <!-- Mobile -->
        <ng-container matColumnDef="mobile">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Mobile</th>
          <td mat-cell *matCellDef="let row">{{ row.accountsDetails?.mobileNbr || '-' }}</td>
        </ng-container>

        <!-- PAN No -->
        <ng-container matColumnDef="pan">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>PAN No</th>
          <td mat-cell *matCellDef="let row">{{ row.accountsDetails?.panCrdNbr || '-' }}</td>
        </ng-container>

        <!-- Aadhar No -->
        <ng-container matColumnDef="aadhaar">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Aadhaar No</th>
          <td mat-cell *matCellDef="let row">{{ row.accountsDetails?.aadharCrdNbr || '-' }}</td>
        </ng-container>

        <!-- Notes -->
        <ng-container matColumnDef="notes">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Notes</th>
          <td mat-cell *matCellDef="let row">{{ row.accountsDetails?.notes || '-' }}</td>
        </ng-container>

        <!-- Amount -->
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
          <td mat-cell *matCellDef="let row">{{ row.amount }}</td>
          </ng-container>
          
          <!-- Debit To -->
          <ng-container matColumnDef="debitTo">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Debit To</th>
            <td mat-cell *matCellDef="let row">{{ row.accountsMapping?.debitTo }}</td>
          </ng-container>
          
          <!-- Credit To -->
          <ng-container matColumnDef="creditTo">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Credit To</th>
            <td mat-cell *matCellDef="let row">{{ row.accountsMapping?.creditTo }}</td>
          </ng-container>
          
          <!-- Actions -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>&nbsp;&nbsp;&nbsp;Actions</th>
            <td mat-cell *matCellDef="let row" class="actions-cell">

              <!-- Edit Button -->
              <button mat-icon-button (click)="lFN_EditReceipt(row);">
                <mat-icon title="Edit Receipt" style="-webkit-text-fill-color: #2a457a">edit</mat-icon>
              </button>

              <!-- Mark Verified Button -->
              <button mat-icon-button (click)="lFN_MarkReceiptVerified(row)">
                <mat-icon title="Mark Verified" style="color: #9e9e9e;">
                  verified
                </mat-icon>
              </button>
              
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          
          <mat-paginator #unverifiedPaginator [pageSizeOptions]="[10,20,30]" showFirstLastButtons></mat-paginator>
          </div>
          </mat-tab>

  <!-- VERIFIED RECEIPTS TAB -->
  <mat-tab label="Verified Receipts">
    <div class="mat-elevation-z8 table-container">

      <table mat-table [dataSource]="verifiedDataSource" class="mat-table fixed-table" matSort>
        <!-- Category -->
        <ng-container matColumnDef="category">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Category</th>
          <td mat-cell *matCellDef="let row">{{ row.txncategory?.name }}</td>
        </ng-container>

        <!-- Book No -->
        <ng-container matColumnDef="bookNo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="bookNo">B.No</th>
          <td mat-cell *matCellDef="let row">{{ row.bookNo }}</td>
        </ng-container>

        <!-- Receipt No -->
        <ng-container matColumnDef="receiptNo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="receiptNo">Receipt No</th>
          <td mat-cell *matCellDef="let row">{{ row.transaction?.receiptIdPrefixed }}</td>
        </ng-container>

        <!-- Date -->
        <ng-container matColumnDef="txnDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
          <td mat-cell *matCellDef="let row">{{ row.transaction?.txnDate | date:'dd/MM/yyyy' }}</td>
        </ng-container>

        <!-- Purpose -->
        <ng-container matColumnDef="purpose">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Purpose</th>
          <td mat-cell *matCellDef="let row">{{ row.purpose?.name }}</td>
        </ng-container>

        <!-- Mode -->
        <ng-container matColumnDef="modeOfPayment">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Mode</th>
          <td mat-cell *matCellDef="let row">{{ row.modeOfPayment }}</td>
        </ng-container>

        <!-- Cheque / Transaction No -->
        <ng-container matColumnDef="txnId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Chequeno/TxnID</th>
          <td mat-cell *matCellDef="let row">{{ row.transaction?.txnId }}</td>
        </ng-container>

        <!-- Bank Name -->
        <ng-container matColumnDef="bank">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Bank Name</th>
          <td mat-cell *matCellDef="let row">{{ row.modeBankName || '-' }}</td>
        </ng-container>

        <!-- Customer Name -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let row">
            {{
            (row.accountsDetails?.salutation ? row.accountsDetails.salutation + ' ' : '') +
            (row.accountsDetails?.firstName ? row.accountsDetails.firstName + ' ' : '') +
            (row.accountsDetails?.lastName || '') || '-'
            }}
          </td>
        </ng-container>

        <!-- Mobile -->
        <ng-container matColumnDef="mobile">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Mobile</th>
          <td mat-cell *matCellDef="let row">{{ row.accountsDetails?.mobileNbr || '-' }}</td>
        </ng-container>

        <!-- PAN No -->
        <ng-container matColumnDef="pan">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>PAN No</th>
          <td mat-cell *matCellDef="let row">{{ row.accountsDetails?.panCrdNbr || '-' }}</td>
        </ng-container>

        <!-- Aadhar No -->
        <ng-container matColumnDef="aadhaar">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Aadhaar No</th>
          <td mat-cell *matCellDef="let row">{{ row.accountsDetails?.aadharCrdNbr || '-' }}</td>
        </ng-container>

        <!-- Notes -->
        <ng-container matColumnDef="notes">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Notes</th>
          <td mat-cell *matCellDef="let row">{{ row.accountsDetails?.notes || '-' }}</td>
        </ng-container>

        <!-- Amount -->
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
          <td mat-cell *matCellDef="let row">{{ row.amount }}</td>
        </ng-container>

        <!-- Debit To -->
        <ng-container matColumnDef="debitTo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Debit To</th>
          <td mat-cell *matCellDef="let row">{{ row.accountsMapping?.debitTo }}</td>
        </ng-container>
        <!-- Credit To -->
        <ng-container matColumnDef="creditTo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Credit To</th>
          <td mat-cell *matCellDef="let row">{{ row.accountsMapping?.creditTo }}</td>
        </ng-container>

        <!-- Actions -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>&nbsp;&nbsp;&nbsp;Actions</th>
          <td mat-cell *matCellDef="let row" class="actions-cell">
            <!-- Edit Button -->
            <button mat-icon-button (click)="lFN_EditReceipt(row);">
              <mat-icon title="Edit Receipt" style="-webkit-text-fill-color: #2a457a">edit</mat-icon>
            </button>

            <!-- Disabled Verified Icon -->
            <button mat-icon-button disabled>
              <mat-icon title="Already Verified" style="color: #3ce51e;">
                verified
              </mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator #verifiedPaginator [pageSizeOptions]="[10,20,30]" showFirstLastButtons></mat-paginator>
    </div>
  </mat-tab>



</mat-tab-group>